import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import AncestryTree from "./components/AncestryTree";
import { Helmet } from "react-helmet";
import ValidatorStats from "./components/ValidatorsStats";
import VouchGraph from "./components/VouchGraph";
import Reward from "./components/Reward";

const Validators = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get("/validators_infos.json")
      .then((response) => setData(response.data))
      .catch((error) => {
        console.error("Error loading the JSON file:", error);
      });
  }, []);

  if (!data) return <div>Loading...</div>;

  return (
    <div className="container mx-auto py-4">
      <Helmet>
        <title>Validators - Libra World from 0L Network</title>
        <meta
          name="description"
          content="Explore Validators data on the 0L Network."
        />
        <link
          rel="canonical"
          href={`https://libra-world.vercel.app/validators`}
        />
      </Helmet>
      <div className="w-full my-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">0L Validators</h1>
        <h2 className="text-xl text-gray-600 max-w-lg mx-auto mb-8">
          Explore validators data on the 0L Network.
        </h2>
        <div className="uk-alert-danger" data-uk-alert>
          <p>This page is currently offline and the data is not up to date.</p>
        </div>
        <ValidatorStats data={data} />
        <div className="uk-margin-medium-top">
          <ul
            id="tab"
            className="uk-flex-center"
            data-uk-tab="{connect:'#tables'}"
          >
            <li>
              <a href="#reward">Reward</a>
            </li>
            <li>
              <a href="#ancestry">Ancestry</a>
            </li>
            <li>
              <a href="#vouches">Vouch</a>
            </li>
          </ul>
          <ul id="graphs" className="uk-switcher uk-margin">
            <li id="reward">
              <Reward />
            </li>
            <li id="ancestry">
              <AncestryTree data={data} />
            </li>
            <li id="vouches">
              <VouchGraph data={data} />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Validators;
